import { Link } from 'react-router-dom';
import { SecurityBlockList } from '@/components/SecurityBlockList';
import { DomainsPanel } from '@/components/settings/DomainsPanel';
import { ReservedSubdomainsPanel } from '@/components/settings/ReservedSubdomainsPanel';
import { WebhookReceiverList } from '@/components/webhooks/WebhookReceiverList';
import { PageHeader } from '@/components/PageHeader';
import { cn } from '@/lib/utils';

type SettingsTab = 'security-blocks' | 'domains' | 'subdomains' | 'webhooks';

const tabs: { id: SettingsTab; label: string; path: string }[] = [
  { id: 'security-blocks', label: 'Security Blocks', path: '/settings/security-blocks' },
  { id: 'domains', label: 'Domains', path: '/settings/domains' },
  { id: 'subdomains', label: 'Reserved Subdomains', path: '/settings/subdomains' },
  { id: 'webhooks', label: 'Webhooks', path: '/settings/webhooks' },
];

function TabContent({ tab }: { tab: SettingsTab }) {
  switch (tab) {
    case 'security-blocks':
      return <SecurityBlockList />;
    case 'domains':
      return <DomainsPanel />;
    case 'subdomains':
      return <ReservedSubdomainsPanel />;
    case 'webhooks':
      return <WebhookReceiverList />;
  }
}

export function SettingsPage({ tab }: { tab: SettingsTab }) {
  return (
    <div className="space-y-6">
      <PageHeader title="Settings" description="Deployment security, domains and certificates, and outbound webhooks." />
      <div className="grid grid-cols-1 gap-8 md:grid-cols-[200px_minmax(0,1fr)]">
        <nav aria-label="Settings" className="flex flex-wrap gap-1 md:flex-col">
          {tabs.map((t) => (
            <Link key={t.id} to={t.path} aria-current={tab === t.id ? 'page' : undefined}
              className={cn('rounded-md px-3 py-2 text-sm font-medium outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring',
                tab === t.id ? 'bg-accent text-accent-foreground' : 'text-muted-foreground hover:bg-muted hover:text-foreground')}>
              {t.label}
            </Link>
          ))}
        </nav>
        <div className="min-w-0">
          <TabContent tab={tab} />
        </div>
      </div>
    </div>
  );
}
